import { Link } from 'react-router-dom';
import './header.css';
export const Header = () => {
  return (
    <header id='home'>
      <div className='intro full-bg'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-8 col-md-offset-2 intro-text' data-aos="zoom-in-down">
              <h1>A Real</h1>
              <h1 className='gradient-header'>Asset Backed NFT</h1>
              <p>RUBYROCK is transforming one of the rarest precious stones into an innovative, secured and highly efficient tokenized asset.</p>
              <Link
                to='/whitelist'
                className='btn btn-custom btn-lg landing-cta'
              >
                Mint
                <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M-1.96729e-07 4.99986C-2.02525e-07 4.86725 0.0526782 4.74007 0.146446 4.6463C0.240215 4.55254 0.367392 4.49986 0.5 4.49986L12.293 4.49986L9.146 1.35386C9.05211 1.25997 8.99937 1.13263 8.99937 0.999857C8.99937 0.867081 9.05211 0.739743 9.146 0.645856C9.23989 0.55197 9.36722 0.499225 9.5 0.499225C9.63277 0.499225 9.76011 0.55197 9.854 0.645856L13.854 4.64586C13.9006 4.6923 13.9375 4.74748 13.9627 4.80822C13.9879 4.86897 14.0009 4.93409 14.0009 4.99986C14.0009 5.06562 13.9879 5.13074 13.9627 5.19149C13.9375 5.25223 13.9006 5.30741 13.854 5.35386L9.854 9.35386C9.76011 9.44774 9.63278 9.50049 9.5 9.50049C9.36722 9.50049 9.23989 9.44774 9.146 9.35386C9.05211 9.25997 8.99937 9.13263 8.99937 8.99986C8.99937 8.86708 9.05211 8.73974 9.146 8.64586L12.293 5.49986L0.5 5.49986C0.367392 5.49986 0.240215 5.44718 0.146446 5.35341C0.0526782 5.25964 -1.90932e-07 5.13247 -1.96729e-07 4.99986Z" fill="white"/>
                </svg>
              </Link>{' '}
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}
